import { denormalize, normalize, schema } from 'normalizr';

//const addNodeTypeProcessStrategy = (value: any, nodeType: ArticleNodeType | SubArticleNodeType | EntityNodeType) => {
//    let copy =cloneDeep(value);  //TODO: do shallow copy with spread(...)
//    let localParent = { ...parent }
//    copy.nodeType = nodeType;
//    return copy
//}

function tempID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + s4();
}

const projectSchema = new schema.Entity(
  'Project',
  {},
  {
    idAttribute: 'Project_ID'
  }
);

const eventSchema = new schema.Entity(
  'Event',
  {},
  {
    idAttribute: () => tempID()
  }
);

const priorTaskSchema = new schema.Entity(
  'PriorTask',
  {},
  {
    idAttribute: 'Task_ID'
  }
);

const nextTaskSchema = new schema.Entity(
  'NextTask',
  {},
  {
    idAttribute: (entity, parent) => {
      return entity.Task_ID > 0 ? entity.Task_ID : tempID(); //potential next task don't have id's
    }
  }
);

const assignmentSchema = new schema.Entity(
  'Assignment',
  {},
  {
    idAttribute: 'Assign_ID'
  }
);

const taskSchema = new schema.Entity(
  'Task',
  {
    Project: projectSchema,
    Prior_Task: priorTaskSchema,
    Next_Tasks: {
      Task: [nextTaskSchema]
    },
    Events: {
      Event: [eventSchema]
    },
    Assignments: {
      Assignment: [assignmentSchema]
    }
  },
  { idAttribute: 'Task_ID' }
);

const taskGetSchema = new schema.Entity(
  'Transaction',
  {
    Task: taskSchema
  },
  {
    idAttribute: (value) => '0'
    //processStrategy: (input, parent, key) => { return addNodeTypeProcessStrategy(input, "Contract_Get") }
  }
);

const taskProcessSchema = new schema.Entity(
  'Transaction',
  {
    Task: taskSchema
  },
  {
    idAttribute: (value) => '0'
    //processStrategy: (input, parent, key) => { return addNodeTypeProcessStrategy(input, "Contract_Process") }
  }
);

const conceptOneRequestSchema = new schema.Entity(
  'Request',
  {
    TaskGet: taskGetSchema,
    TaskProcess: taskProcessSchema
  },
  {
    idAttribute: (value) => '0'
    //processStrategy: (input, parent, key) => { return addNodeTypeProcessStrategy(input, "ConceptOneRequest") }
  }
);

const conceptOneReplySchema = new schema.Entity(
  'Reply',
  {
    TaskGet: taskGetSchema,
    TaskProcess: taskProcessSchema
  },
  {
    idAttribute: (value) => '0'
    //processStrategy: (input, parent, key) => { return addNodeTypeProcessStrategy(input, "ConceptOneReply") }
  }
);

// in root ID:0 = reply from LOAD    ID:1 = transaction being built for PROCESS
export const rootSchema = new schema.Entity(
  'Root',
  {
    ConceptOneRequest: conceptOneRequestSchema,
    ConceptOneReply: conceptOneReplySchema
  },
  { idAttribute: (value) => '0' }
);

export { normalize };
export { denormalize };
